import { css } from 'styled-components';
import { Colors, getColor } from '../../styles/theme';

export type DashedFocusBorderProps = {
    offset?: string;
    focusColor?: string;
};

export type DashedFocusBorderNormalProps = {
    offset?: string;
    color?: Colors;
};

/**
 * The HTML element this styled is applied to should be selectable
 * @props offset offset of the dashed focus border, default to 2px
 */
export const DashedFocusBorder = (args: DashedFocusBorderNormalProps = {}) => css`
    :focus {
        transition: outline 0.001ms;
        outline: 1px dashed ${(props) => (args.color ? getColor(props.theme, args.color) : props.theme.color.grey4)};
        outline-offset: ${args.offset ?? '-3px'};
    }
`;

export const DashedFocusBorderAbsolute = css<DashedFocusBorderProps>`
    :focus-visible::after {
        content: '';
        position: absolute;
        inset: 0;
        transition: outline 0.001ms;
        outline: 1px dashed
            ${(props) => (props.focusColor ? getColor(props.theme, props.focusColor) : props.theme.color.grey4)};
        outline-offset: ${(props) => props.offset || '-3px'};
        border-radius: 8px;
    }
`;
